export const getAvailabilityShorthand = (shortString) => {
    if (shortString === 'voltijd') return 'Fulltime';
    if (shortString === 'deeltijd') return 'Parttime';
    if (shortString === 'voltijd-of-deeltijd') return 'Fulltime of parttime';
};
